import { Button, Stack, Tooltip, Typography } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import { trackEvent } from "src/Amplitude";
import api from "src/store/features/api";
import { useMarketsState } from "src/store/features/markets.slice";
import { getTicker } from "src/utils/hooks/useGetTicker";
import { isTokenRestrictedForCountry } from "src/utils/restrictedCountry";

export default function TradeAndTargetButtons() {
  const token = getTicker();
  const toolTipTrade =
    "We currently do not support trading on this coin. Please contact us at support@calebandbrown.com if you need further assistance or you think this is incorrect.";

  const buttonStyles = {
    color: "white",
    background: "#002035",
    width: "100%",
    borderRadius: "10px",
    textTransform: "none",
    padding: "10px",
    maxHeight: "37px",
  };

  const text = {
    color: "#FFF",
    fontFamily: "Roobert",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "19px",
  };

  const history = useHistory();
  const {
    coinStatistics: { currencyConfig },
  } = useMarketsState();

  const { data: userData } = api.useGetUserDatav2Query();
  const isRestrictedForUserCountry = isTokenRestrictedForCountry(
    currencyConfig,
    userData?.address?.country,
  );

  const tradePermissions =
    ((currencyConfig?.permissions && currencyConfig.permissions.buy) ||
      (currencyConfig?.permissions && currencyConfig.permissions.sell)) &&
    !isRestrictedForUserCountry;

  return (
    <Stack direction="row" spacing={1} justifyContent={"center"} my={2} flex={1}>
      <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              background: "#002035",
              fontSize: "14px",
            },
          },
        }}
        title={toolTipTrade}
        disableHoverListener={tradePermissions}>
        <span style={{ width: "100%" }}>
          <Button
            disableRipple
            disabled={!tradePermissions}
            variant={"contained"}
            sx={buttonStyles}
            onClick={() => {
              trackEvent("User_Redirect_To_Trade_From_Coin_Page", { token });
              history.push("/trade");
            }}>
            <Typography sx={text}>{"Trade"}</Typography>
          </Button>
        </span>
      </Tooltip>
      <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              background: "#002035",
              fontSize: "14px",
            },
          },
        }}
        title={toolTipTrade}
        disableHoverListener={tradePermissions}>
        <span style={{ width: "100%" }}>
          <Button
            disableRipple
            disabled={!tradePermissions}
            onClick={() => {
              trackEvent("Coin_Page", { token }, "Target_Button_Pressed");
              history.push("/targets");
            }}
            variant={"contained"}
            sx={buttonStyles}>
            <Typography sx={text}>{"Target"}</Typography>
          </Button>
        </span>
      </Tooltip>
    </Stack>
  );
}
